import React from "react";

export default function LegalPage({ title, children }) {
  return (
    <div style={{
      minHeight: "100vh",
      background: "#f7faf9",
      padding: "48px 20px",
      fontFamily: "Roboto, Arial, sans-serif",
      color: "#1f2937"
    }}>
      <div style={{
        maxWidth: "900px",
        margin: "0 auto",
        background: "#ffffff",
        padding: "40px",
        borderRadius: "16px",
        boxShadow: "0 8px 24px rgba(0,0,0,0.06)"
      }}>
        <div style={{
          fontFamily: "Poppins, Arial, sans-serif",
          fontSize: "28px",
          fontWeight: 700,
          marginBottom: "24px"
        }}>
          {title}
        </div>

        <div style={{
          fontSize: "15px",
          lineHeight: 1.75
        }}>
          {children}
        </div>
      </div>
    </div>
  );
}
